interface Article {
  Sku: string
  Title: string
  TitleLong: string
}

interface Summary {
  Price: number
}

interface PricehelperResponseData {
  articles: Article[]
  summary: Summary
}

const generateGtmScripts = (
  PricehelperResponseData: PricehelperResponseData | undefined,
  articleErpItemNumber: string,
  category: string,
  subCategory: string,
  weeksUntilDelivery: string,
  structSku?: string
) => {
  if (!PricehelperResponseData) return

  return `
      <script id="productView">dataLayer.push({ 
        'ecommerce' : { 
          'detail' : { 
            'products' : [{ 
              'id' : ${structSku ? structSku : articleErpItemNumber}, 
              'name' : ${PricehelperResponseData.articles[0].Title} - ${
    PricehelperResponseData.articles[0].TitleLong
  }, 
              'category' : ${category}, 
              'subcategory' : ${subCategory}, 
              'price' : ${PricehelperResponseData.summary.Price}, 
              'deliverytime' : ${weeksUntilDelivery},
            }] 
            } 
          }, 
          'event' : 'productView' 
        });
      </script>
    `
}

export const generateGtmScriptNode = (
  PricehelperResponseData: PricehelperResponseData | undefined,
  articleErpItemNumber: string,
  category: string,
  subCategory: string,
  weeksUntilDelivery: string,
  structSku: string | undefined
): HTMLElement | null => {
  const scriptContent = generateGtmScripts(
    PricehelperResponseData,
    articleErpItemNumber,
    category,
    subCategory,
    weeksUntilDelivery,
    structSku
  )

  if (!scriptContent) return null

  const template = document.createElement('template')
  template.innerHTML = scriptContent.trim()
  return template.content.firstElementChild as HTMLElement
}
